/**
 * @file   : SectionFlipCard.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 7:01:21 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import FlipCard from '../../../external/components/container/flipCard/FlipCard'
import { sendToExternalPath } from '../../../router/RouteManager'
import { translate } from '../../Translation'
import MarketingSpot from '../../home/marketing/MarketingSpot'
import MarketingSpotInfo from '../../home/marketing/MarketingSpotInfo'
import { getLinkObj, getMarketingSpotFromContent } from '../InfoUtil'

const SectionFlipCard = ({
  intl,
  theme,
  content,
  infoData,
  showCardBack = true,
  cardSize = '3x',
}) => {
  const onMarketingSpotSelectRequest = function (marketingSpot) {
    sendToExternalPath(marketingSpot.link, marketingSpot.newWindow)
  }

  const spot = getMarketingSpotFromContent(intl, content, infoData)
  const cardContentFront = (
    <MarketingSpot
      theme={theme}
      intl={intl}
      getMarketingSpotSelectLinkObj={getLinkObj}
      onMarketingSpotSelectRequest={onMarketingSpotSelectRequest}
      marketingSpot={spot}
    />
  )
  const cardLabelBtnFront = translate(intl, 'label_flip_card_front_btn', {
    description: spot.title,
  })
  const cardLabelBtnBack = translate(intl, 'label_flip_card_back_btn', {
    description: spot.title,
  })

  let cardContentBack = null
  if (showCardBack) {
    cardContentBack = (
      <MarketingSpotInfo
        theme={theme}
        intl={intl}
        getMarketingSpotSelectLinkObj={getLinkObj}
        onMarketingSpotSelectRequest={onMarketingSpotSelectRequest}
        marketingSpot={spot}
      />
    )
  }

  return (
    <FlipCard
      isShowMoreButton={showCardBack}
      cardSize={cardSize}
      cardContentFront={cardContentFront}
      cardContentBack={cardContentBack}
      cardLabelBtnFront={cardLabelBtnFront}
      cardLabelBtnBack={cardLabelBtnBack}
    />
  )
}

SectionFlipCard.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string,
  content: PropTypes.object,
  infoData: PropTypes.object,
  showCardBack: PropTypes.bool,
  cardSize: PropTypes.string,
}

export default SectionFlipCard
